import i18n from 'live/services/i18n'
import HistogramWidgetController from './HistogramWidgetController'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { histogramReducer } from './reducer'
import { HistogramEvent, HistogramState } from './types'

const widgetType = 'histogram'

const HistogramWidget = reactWidgetWrapper<HistogramState, FlowMessage<HistogramEvent>, DefaultChartConfigs>(
    HistogramWidgetController,
    histogramReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget
            }
        }
    }
)

export const DEFAULT_CHART_CONFIG: LiveWidgetConfig = {
    legendEnabled: true,
    legendRight: false
}

const policies = {
    defaultReducer: ' ',
    layers: 1,
    legends: true
}

widgetService.register({
    type: widgetType,
    get name() {
        return i18n('Histogram')
    },
    policies,
    config: undefined,
    /* Description taken from https://en.wikipedia.org/wiki/Histogram */
    description: i18n('A histogram is an approximate representation of the distribution of numerical data.'),
    impl: HistogramWidget
})
